<!--
 * @Author: hongqi
 * @LastEditors: hongqi
 * @Date: 2021-01-08 10:10:16
 * @LastEditTime: 2021-01-09 10:27:07
-->
<template>
    <div class="index">
        <div class="searchGood" ref="container">
            <div class="search acea-row row-between-wrapper bg-color" style="background: #d01112;">
                <div class="input acea-row row-between-wrapper">
                    <span class="iconfont icon-sousuo2"></span>
                    <form @submit.prevent="submit"></form>
                    <input type="text" placeholder="输入积分商品名称" v-model="where.keyword" />
                </div>
                <div class="bnt" @click="submit">搜索</div>
            </div>
        </div>
        <div class="productList">
            <div class="nav acea-row row-middle">

                <div class="item" @click="set_where(1)">
                    价格
                    <img src="@assets/images/horn.png" v-if="price === 0" />
                    <img src="@assets/images/up.png" v-if="price === 1" />
                    <img src="@assets/images/down.png" v-if="price === 2" />
                </div>
                <div class="item" @click="set_where(2)">
                    销量
                    <img src="@assets/images/horn.png" v-if="stock === 0" />
                    <img src="@assets/images/up.png" v-if="stock === 1" />
                    <img src="@assets/images/down.png" v-if="stock === 2" />
                </div>
                <!-- down -->
                <div class="item">
                    <div class="iconfont" :class="Switch === true ? 'icon-pailie' : 'icon-tupianpailie'" @click="switchTap"></div>
                    <img src="../../assets/newImg/integer_filter_icon.png" class="integer-filter-icon" @click.stop="filterTap">
                </div>
            </div>
        </div>
        <div class="slider-banner banner">
            <swiper :options="swiperOption" v-if="banner.length > 0">
                <swiper-slide v-for="(item, index) in banner" :key="index"  @click="goDetails(item)">
                    <img :src="item.pic" @click="goDetails(item)" />
                </swiper-slide>
                <div class="swiper-pagination paginationBanner" slot="pagination"></div>
            </swiper>
        </div>
        <img src="@assets/newImg/tuihuo.png" class="tuihuo" alt="">
        <div class="productList" ref="container">
            <div class="list acea-row row-between-wrapper" :class="Switch === true ? '' : 'on'" ref="container">
                <div @click="goDetail(item)" v-for="(item, index) in productList" :key="index" class="item" :class="Switch === true ? '' : 'on'" :title="item.store_name">
                    <div class="pictrue" :class="Switch === true ? '' : 'on'">
                        <img :src="item.image" :class="Switch === true ? '' : 'on'" />
                        <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '1'">秒杀</span>
                        <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '2'">砍价</span>
                        <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '3'">拼团</span>
                    </div>
                    <div class="text" :class="Switch === true ? '' : 'on'">
                        <div class="name line1">{{ item.store_name }}</div>
                        <div class="name line1" style="color:#999999;font-size:12px;height:20px;line-height:20px">
                            {{ item.store_info }}
                        </div>
                        <div class="go-shop">
                            <div class="money font-color-red" :class="Switch === true ? '' : 'on'">
                                <span class="num">{{ item.price }}积分</span>
                            </div>
                            <div class="go">
                                立即兑换
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Loading :loaded="loadend" :loading="loading"></Loading>
            <div class="noCommodity" v-cloak style="background-color: #fff;" v-if="productList.length === 0 && where.page > 1">
                <div class="noPictrue">
                    <img src="@assets/images/noGood.png" class="image" />
                </div>
            </div>
        </div>
        <div style="height:.25rem"></div>
        <van-popup v-model="filterShow" position="right" overlay-class="content">
            <div class="contents">
                <ul class="mod_list">
                    <li class="">
                        <div class="list_inner li_line">
                            <div class="big">用户优选</div>
                            <div class="right"><span class="words_10" r-mark="13260" slen="1" style="max-width: 210px;"></span></div>
                        </div>
                    </li>
                     <div class="tags_selection all"  @click="selectCateAll" >
                        <div :class="selectIndex==88 ?'option selected':'option'">
                            <a  href="javascript:void 0;">全部</a>
                        </div>
                    </div>
                    <div class="tags_selection" v-for="(item,index) in dataSource" :key="index" @click="selectCate(item.id,index)">
                        <div :class=" selectIndex==index ? 'option selected':'option'" >
                            <a  href="javascript:void 0;">{{item.cate_name}}</a>
                        </div>
                    </div>
                    <div class="tags_selection sub_list"> </div>
                </ul>
                <div class="filterlayer_bottom_buttons">
                    <span class="filterlayer_bottom_button btn_close" id="filterCBtn" rd="0-9-2" @click="selectClose"></span>
                    <span class="filterlayer_bottom_button bg_1 hide" id="filterBBtn" @click="selectCateReset">重置</span>
                    <span class="filterlayer_bottom_button bg_2 hide" id="filterSureBtn" rd="0-13-4" @click="selectCateOk">确认</span>
                </div>
            </div>
        </van-popup>
       <!-- <Recommend v-if="productList.length === 0 && where.page > 1"></Recommend> -->
        <div style="height:1.2rem;"></div>
    </div>
</template>

<script>
// import Recommend from "@components/Recommend";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { getHomeData } from "@api/public";
import { getProducts } from "@api/store";
import { categoryList } from "@api/user";
import { Popup } from "vant";
import Loading from "@components/Loading";
import "@assets/css/swiper.min.css";
export default {
    components: {
        Loading,
        swiper,
        swiperSlide,
        "van-popup": Popup,
        // Recommend
    },
    data() {
        const { s = "", id = 0, title = "" } = this.$route.query;
        return {
            hostProduct: [],
            productList: [],
            Switch: true,
            filterShow: false,
            where: {
                page: 1,
                limit: 8,
                keyword: s,
                sid: id, //二级分类id
                news: 0,
                priceOrder: "",
                salesOrder: "",
                shop_type:3,
            },
            title: title && id ? title : "",
            loadTitle: "",
            loading: false,
            loadend: false,
            price: 0,
            stock: 0,
            nows: false,
            swiperOption1: {
                pagination: {
                    el: ".paginationBanner",
                    clickable: false,
                },
                autoplay: {
                    disableOnInteraction: false,
                    delay: 2000,
                },
                loop: true,
                speed: 1000,
                observer: true,
                observeParents: true,
                dataSource:[]
            },
            swiperOption2: {
                pagination: {
                    el: ".paginationBanner",
                    clickable: false,
                },
                autoplay: false,
                loop: true,
                speed: 1000,
                observer: true,
                observeParents: true,
                dataSource:[]
            },
            banner: [],
            logoUrl: localStorage.getItem("logoUrl"),
            selectIndex:88
        };
    },
    mounted() {
        // this._onShowLoading();
        this.cateList()
        this._onQueryBindAccount()
        // getHomeData().then((res) => {
        //     this.banner = res.data.banner;
        // });
        this.get_product_list();
    },
    computed:{
        swiperOption(){
        var len = this.banner.length
        if(len == 1){
          return this.swiperOption2
        }else{
          return this.swiperOption1
        }
      },
    },
    methods: {
        /**分类 */
        cateList(){
            categoryList().then(res=>{
               this.dataSource=res.data.data.store_category_list3;
               this.banner=res.data.data.banner_integral;
            })
        },
        /**分类选择 */
        selectCate(id,index){
            this.$set(this, "productList", []);
            this.where.page = 1;
            this.loadend = false;
            this.where.sid = id;
            this.selectIndex=index;
            this.get_product_list();
        },
        /**选择全部*/
        selectCateAll(){
            this.$set(this, "productList", []);
            this.where.page = 1;
            this.loadend = false;
            this.where.sid = '';
            this.selectIndex=88;
            this.get_product_list();
        },
        selectCateOk(){
            this.filterShow = false;
        },
        selectCateReset(){
            this.selectIndex=0;
        },
        selectClose(){
            this.filterShow = false;
        },
        // 商品详情跳转
    goDetail(item) {
        this.$router.push({
          path: "/detail/" + item.id + "?shop_type=3"
        });
    },
    goDetails(item) {
        this.$router.push({
          path: "/detail/" + item.product_id + "?shop_type=3"
        });
    },
        filterTap() {
            this.filterShow = true;
        },
        submit() {
            this.$set(this, "productList", []);
            this.where.page = 1;
            this.loadend = false;
            this.loading = false;
            this.get_product_list();
        },
        switchTap: function () {
            let that = this;
            that.Switch = !that.Switch;
        },
        //点击事件处理
        set_where: function (index) {
            let that = this;
            switch (index) {
                case 0:
                    return that.$router.push({ path: "/category" });
                case 1:
                    if (that.price === 0) that.price = 1;
                    else if (that.price === 1) that.price = 2;
                    else if (that.price === 2) that.price = 0;
                    that.stock = 0;
                    break;
                case 2:
                    if (that.stock === 0) that.stock = 1;
                    else if (that.stock === 1) that.stock = 2;
                    else if (that.stock === 2) that.stock = 0;
                    that.price = 0;
                    break;
                case 3:
                    that.nows = !that.nows;
                    break;
                default:
                    break;
            }
            that.$set(that, "productList", []);
            that.where.page = 1;
            that.loadend = false;
            that.get_product_list();
        },
        //设置where条件
        setWhere: function () {
            let that = this;
            if (that.price === 0) {
                that.where.priceOrder = "";
            } else if (that.price === 1) {
                that.where.priceOrder = "asc";
            } else if (that.price === 2) {
                that.where.priceOrder = "desc";
            }
            if (that.stock === 0) {
                that.where.salesOrder = "";
            } else if (that.stock === 1) {
                that.where.salesOrder = "asc";
            } else if (that.stock === 2) {
                that.where.salesOrder = "desc";
            }
            that.where.news = that.nows ? "1" : "0";
        },
        get_product_list() {
            var that = this;
            if (that.loading) return; //阻止下次请求（false可以进行请求）；
            if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
            that.loading = true;
            this.setWhere();
            let q = that.where;
            getProducts(q).then((res) => {
                that.loading = false;
                that.productList.push.apply(that.productList, res.data);
                that.loadend = res.data.length < that.where.limit; //判断所有数据是否加载完成；
                that.where.page = that.where.page + 1;
            });
            setTimeout(() => that._onHideLoading(), 1000)
        },
    },
};
</script>

<style lang="scss" scoped>
.index .header {
    background: #d01112;
}
.index .header .logo {
    width: 2.12rem;
    height: 0.72rem;
}
.index .header .logo img {
    object-fit: contain;
}
.index .header .search {
    width: 4.56rem;
    height: 0.56rem;
    padding: 0 0.4rem;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 0.32rem;
    color: #ffffff;
}
.productList .list .item .text .money .num {
    font-size: 0.3rem;
}
.index .header .search .iconfont {
    margin-right: 0.28rem;
}
.contents {
    width: 6.5rem;
    height: 100vh;
    background: #fff;
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
    .mod_list{
        padding-bottom: 10px;
    }
    .mod_list li {
        position: relative;
        line-height: 25px;
        padding: 10px;
        border-bottom: 1px solid #ccc;
    }
    .mod_list .li_line {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
    }
    .mod_list .li_line .big {
        height: 25px;
        max-width: 250px;
        overflow: hidden;
        font-size: 16px;
        color: #333;
        text-overflow: ellipsis;
    }
    .mod_list .li_line .right {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        flex: 1;
        margin-left: 5px;
        text-align: right;
        font-size: 12px;
        color: #999;
    }
    .words_10 {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        vertical-align: middle;
        text-align: right;
        max-width: 110px;
    }
    .mod_list .tags_selection {
        position: relative;
        margin: 0;
        // padding: 10px 0 0 10px;
        padding-left: 10px;
    }
    .mod_list .tags_selection::before {
            content: "";
            position: absolute;
            z-index: 1;
            pointer-events: none;
            // background-color: #e5e5e5;
            height: 1px;
            left: 0;
            right: 0;
            top: 0;
            left: 10px;
        }
        .mod_list .sub_list.tags_selection {
    display: none;
}
.tags_selection .option.selected a:after {
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
    width: 15px;
    height: 15px;
    border-radius: 0 0 2px 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeBAMAAADJHrORAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTOQ4POQ5PPrV1f///+dGSO17ff3u7/Kio+lcXvW4uZrptW4AAAACdFJOUwB/timhlQAAAH1JREFUGNNdzkEOQDAQheG6Qo/whNjjBBWs9QbiCFzExl4cFG1HzOvuz5fpjDHqZTqNJQYxiEEMYhCDGMQgBjGIQQxiEOPPRf114NxJx+lrkw5cDXvqyEsv/z1cT2U3p365aY9R9r3T3q1n6ri7cXJPPM23qeVyudfq1gxi3DyiIhPh30TpAAAAAElFTkSuQmCC) no-repeat;
    background-size: 15px auto;
    overflow: hidden;
    z-index: 1;
}
.tags_selection .option.selected a {
    color: #e4393c;
    background-color: #fdf0f0;
    height: 30px;
    line-height: 30px;
}
    .tags_selection .option {
    box-sizing: border-box;
    float: left;
    width: fit-content;
    padding-right: 10px;
    height: 30px;
    line-height: 30px;
    margin-bottom: 10px;
    overflow: hidden;
}
.tags_selection .option a {
    position: relative;
    display: block;
    padding: 0 5px;
    color: #666;
    background-color: #f7f7f7;
    border-radius: 4px;
    text-align: center;
}
}
.productList .nav .item .integer-filter-icon {
    width: 0.36rem;
    height: 0.36rem;
}
.productList .nav .item {
    display: flex;
    justify-content: center;
    align-items: center;
}
.index .banner {
    width: 100%;
    margin: 0 auto;
    height: 4rem !important;
}
.index .banner img {
    height: 4rem;
}
.productList .list .item .text {
    padding: 0.2rem 0.17rem 0.1rem 0.17rem;
}
.filterlayer_bottom_buttons {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    z-index: 100;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0 -1px 2px 0 rgba(0,0,0,.07);
}
.filterlayer_bottom_buttons .filterlayer_bottom_button.btn_close {
    position: relative;
    -webkit-box-flex: 0;
    -webkit-flex: none;
    flex: none;
    width: 50px;
    background: #fff url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURUdwTM3NzczMzM/Pz9TU1MzMzMzMzMzMzMzMzM7Ozs3Nzc3NzczMzMzMzM/Pz83NzczMzNPxTqsAAAAQdFJOUwBm1icN4oz27TNBUcWzGnbbkATbAAAA1ElEQVQ4y9XUyw6EIAwF0IpUFAbl/792KKMOjxbcygrLMWkuDQAvWRMu8uGC073HEES5hID5hySrIy9Jcj4vCLJxoFmZnC5r+hOLR1k7Yumj679bybtWSu6Ud7iT6ErZc1GqS5JTWr7XS44cwE7SOXJ7f5CSfOCiRHK4PxjOkKckL2sIGvvEIY4luXWe15HckgNIcuu4eL5u106Wf1fue64n677s2S/rbJtA45jsUqbz2HGSJsG4th9nqvlQvPtJlQVD08pnRjOcReGVk27BKf+W1xu+l8MOwbyeFd0AAAAASUVORK5CYII=) 50% no-repeat;
    background-size: 20px;
}
.filterlayer_bottom_buttons .filterlayer_bottom_button.btn_close:after {
    content: "";
    position: absolute;
    z-index: 1;
    pointer-events: none;
    background-color: #e5e5e5;
    width: 1px;
    top: 0;
    bottom: 0;
    right: 0;
    right: -6px;
    top: 8px;
    bottom: 7px;
}

.filterlayer_bottom_buttons .filterlayer_bottom_button {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    font-size: 16px;
    height: 49px;
    line-height: 49px;
    text-align: center;
}
.filterlayer_bottom_buttons .filterlayer_bottom_button.bg_1 {
    color: #333;
    background-color: #fff;
}
.filterlayer_bottom_buttons .filterlayer_bottom_button.bg_2 {
    color: #fff;
    background-color: #e4393c;
}
.productList .nav {
    position: relative;
    top: 0;
    justify-content: space-between;
    box-shadow: 0px 4px 10px 0px rgba(173, 39, 39, 0.06);
}
.productList .list .item .text .money {
    margin-top: 0;
}
.productList .list {
    margin-top: 0;
}
.go-shop {
    /* height: 33px; */
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.go-shop .go {
    width: 1.28rem;
    height: 0.4rem;
    background: #d01112;
    border-radius: 13px;
    line-height: 0.4rem;
    color: #fff;
    background: #d01112;
    font-size: 12px;
    text-align: center;
}
.productList .list .item {
    box-shadow: 0px 2px 30px 0px rgba(157, 157, 157, 0.2);
}
.searchGood .search .input {
    background: rgba(255, 255, 255, 0.4);
    input {
        color: #fff;
        &::placeholder {
            color: #fff;
        }
    }
    .iconfont {
        color: #fff;
    }
}
.productList .list .item.on {
    margin-top: 0.2rem;
    padding: 0.3rem 0.2rem;
    box-sizing: border-box;
}
.searchGood .search {
    margin-top: 0;
    height: 0.94rem;
    line-height: 0.94rem;
}
.searchGood .search .bnt {
    color: #fff;
}
.searchGood .search .input {
    line-height: 0.66rem;
}
.tuihuo{
    margin: 10px auto 0 auto;
    width: 355px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.contents .mod_list .all{
    // padding: 10px 0 0 0;
    padding-left: 10px;
    margin-top: 10px;
}
</style>